var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.86 137.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "switch-arrow top-arrow",
    d: "M54.93,135.8v-6.08A68.91,68.91,0,0,1,7.47,31a.35.35,0,0,1,.65.28A52.26,52.26,0,0,0,54.93,100V92.82a2.08,2.08,0,0,1,3.43-1.58l25.26,21.49a2.08,2.08,0,0,1,0,3.17L58.36,137.39A2.08,2.08,0,0,1,54.93,135.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "switch-arrow bottom-arrow",
    d: "M118.74,106.57A52.26,52.26,0,0,0,71.93,37.86v7.2a2.08,2.08,0,0,1-3.43,1.59L43.24,25.16a2.08,2.08,0,0,1,0-3.17L68.5.5a2.08,2.08,0,0,1,3.43,1.59V8.17a68.91,68.91,0,0,1,47.46,98.68A.36.36,0,0,1,118.74,106.57Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSwitch);
export default __webpack_public_path__ + "static/media/searchSwitch.08d8f4c1ea006aabb3470add0462c5e3.svg";
export { ForwardRef as ReactComponent };